type Props = {
  // Raw string
  heading: string;
  // The p tag etc
  children?: React.ReactNode;
  background: 'pink' | 'yellow';
};

/**
 * A CTA component
 * @param props
 */
let CTA = (props: Props) => {
  return (
    <div className={`CTA CTA--${props.background}`}>
      {/* TODO: is h3 good? */}
      <div className="page-width page-width--sm mobile-padding">
        <h3 className="CTA__heading">{props.heading}</h3>
        {props.children}
      </div>
    </div>
  );
};

export default CTA;
